import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON } from './constants';
import theme from './theme';
import sx from './sx';
function IconWrapper(_ref) {
  var IconComponent = _ref.icon,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, ["icon", "className"]);
  return /*#__PURE__*/React.createElement(IconComponent, _extends({
    className: className
  }, rest));
}
IconWrapper.displayName = "IconWrapper";
var StyledOcticon = styled(IconWrapper).withConfig({
  displayName: "StyledOcticon",
  componentId: "sc-7ly0uy-0"
})(["", " ", ""], COMMON, sx);
StyledOcticon.defaultProps = {
  theme: theme,
  size: 16
};
StyledOcticon.propTypes = _objectSpread({}, COMMON.propTypes, {}, sx.propTypes, {
  icon: PropTypes.elementType.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium', 'large'])]),
  theme: PropTypes.object,
  verticalAlign: PropTypes.oneOf(['middle', 'text-bottom', 'text-top', 'top'])
});
export default StyledOcticon;